/** Zeitangaben der ACC-Seite (AC1): „26.10.2026, 14:05“ in Ortszeit des Browsers, leer bei einer Fehlstelle. */
const ZEIT = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
});

export function zeitpunkt(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : ZEIT.format(d);
}
